import React from "react"
import {
  createStyles,
  forwardRef,
  HTMLStyledProps,
  styled,
} from "@design-system/core"
import { __DEV__ } from "@design-system/utils"
import { useModalContext } from "./ModalContext"

export interface ModalFooterProps extends HTMLStyledProps<"footer"> {}

const styles = createStyles((theme) => ({
  footer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    paddingTop: theme.spaces.spacing16,
    paddingHorizontal: theme.spaces.spacing32,
    paddingBottom: theme.spaces.spacing32,
  },
  widthSmall: {
    paddingHorizontal: theme.spaces.spacing16,
  },
}))

export const ModalFooter = forwardRef<ModalFooterProps, "footer">(
  (props, ref) => {
    const { style, ...others } = props
    const { widthSmall } = useModalContext()
    return (
      <styled.footer
        {...others}
        style={[styles.footer, widthSmall && styles.widthSmall, style]}
        ref={ref}
      />
    )
  },
)

if (__DEV__) {
  ModalFooter.displayName = "ModalFooter"
}
